/**
 * Medical concept codes used throughout the application
 */

// Export individual constants for convenience
export const DEATH_CONCEPT_CODE = "4306655";
export const FAMILY_HISTORY_OF_CLINICAL_FINDING = "4167217";
export const HISTORY_OF_EVENT = "1340204";
